export default __webpack_public_path__ + "static/media/TOU_Logo_colour.ac72c26e.png";